import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import TermsOfService from './pages/TermsOfService';
import Register from './pages/Register';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import GoogleCallback from './pages/GoogleCallback';
import UserProfile from './pages/UserProfile';
import PatientInfo from './pages/PatientInfo';
import LegMeasuring from './pages/LegMeasuring';
import StockingSelection from './pages/StockingSelection';
import Order from './pages/Order';
import Dashboard from './pages/Dashboard';
import Patients from './pages/Patients';
import UserManagement from './pages/UserManagement';
import OrganizationSettings from './pages/OrganizationSettings';
import ProductOptionsManagement from './pages/ProductOptionsManagement';

const NO_FOOTER_ROUTES = ['/leg-measuring', '/patient-info', '/stocking-selection', '/order'];
const FIXED_HEIGHT_ROUTES = ['/leg-measuring'];

function AppLayout({ children }) {
    const location = useLocation();
    const showFooter = !NO_FOOTER_ROUTES.includes(location.pathname);
    const fixedHeight = FIXED_HEIGHT_ROUTES.includes(location.pathname);
    return (
        <div className={fixedHeight ? 'flex flex-col h-screen overflow-hidden' : 'flex flex-col min-h-screen'}>
            <Header />
            <main className={fixedHeight ? 'flex-1 min-h-0 overflow-hidden' : 'flex-grow'}>{children}</main>
            {showFooter && <Footer />}
        </div>
    );
}

function App() {
    return (
        <AuthProvider>
            <Router>
                <AppLayout>
                    <Routes>
                        {/* Public routes */}
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<TermsOfService />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:token" element={<ResetPassword />} />
                        <Route path="/auth/google/callback" element={<GoogleCallback />} />

                        {/* Protected routes */}
                        <Route
                            path="/dashboard"
                            element={
                                <PrivateRoute>
                                    <Dashboard />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/patients"
                            element={
                                <PrivateRoute>
                                    <Patients />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/profile"
                            element={
                                <PrivateRoute>
                                    <UserProfile />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/user-management"
                            element={
                                <PrivateRoute>
                                    <UserManagement />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/organization-settings"
                            element={
                                <PrivateRoute>
                                    <OrganizationSettings />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/product-options"
                            element={
                                <PrivateRoute>
                                    <ProductOptionsManagement />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/patient-info"
                            element={
                                <PrivateRoute>
                                    <PatientInfo />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/leg-measuring"
                            element={
                                <PrivateRoute>
                                    <LegMeasuring />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/stocking-selection"
                            element={
                                <PrivateRoute>
                                    <StockingSelection />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/order"
                            element={
                                <PrivateRoute>
                                    <Order />
                                </PrivateRoute>
                            }
                        />
                    </Routes>
                </AppLayout>
            </Router>
        </AuthProvider>
    );
}

export default App;
